import React from 'react';

const Loader = () => {
  // From: https://loading.io/css/
  return (
    <div className="loader"></div>
  );
}

export default Loader;
